import * as React from 'react';
import { observer } from 'mobx-react';
import { PaymentLabel, FrequencyCode } from '../webgiving-generated';
import { Text } from '../components/text';
import { Button, ButtonStyle } from '../primitives/button/button';
import { frequencyLabelLowerCase } from '../utils/recurring-utils';
import { Formatter } from '../../Shared/utils/formatter';

export const RecurringSuggestionButton: React.FC<{
	isLoading: boolean;
	paymentLabel: PaymentLabel;
	frequency: FrequencyCode;
	acceptanceTestTargetId: string;
	amount: number;
	onClick?: () => void;
}> = observer(({ acceptanceTestTargetId, isLoading, paymentLabel, amount, onClick, frequency }) => {
	return (
		<Button
			className="button"
			onClick={onClick}
			buttonStyle={ButtonStyle.Ghost}
			acceptanceTestTargetId={acceptanceTestTargetId}
			isLoading={isLoading}
		>
			<Text>{paymentLabel.VerbSentenceCase}</Text>
			{` $${Formatter.formatNumberForDisplay(amount, 2)}`}
			{frequency === FrequencyCode.FirstAndFifteenth ? <Text> on </Text> : ' '}
			<Text>{frequencyLabelLowerCase(frequency)}</Text>
		</Button>
	);
});
